import { useMemo } from 'react';
import { BASE_HEIGHT, TABLE_HEIGHT_MAPPING } from '../header/Resize';
import { useAtomValue } from 'jotai';
import { heightAtom } from '../atoms';

function useGrid({ data, isError, isFetching, updateGrid, fixedHeight = false }) {
  const height = useAtomValue(heightAtom);

  useMemo(() => {
    const gridRow = Math.min(
      TABLE_HEIGHT_MAPPING[height],
      fixedHeight ? Infinity : BASE_HEIGHT + data.length,
    );
    if (!isError && !isFetching) {
      updateGrid(gridRow);
    }
  }, [data, isError, isFetching, height, fixedHeight, updateGrid]);
}

export default useGrid;
